






import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    TheLayoutPortal
  }
})
export default class Test extends Vue {}
